import { Grid, TextField } from "@mui/material";
import { DropDownList } from "./DropDownList";
import { useEffect, useState } from "react";
import { constantes } from "./config";

function UnidadMedida({
  index,
  unidades,
  setUnidades,
  selectedCategoria,
  selectedUnidad,
  currentCantidad,
}) {
  const [categoria, setCategoria] = useState({
    Id: selectedCategoria || "",
    Nombre: "",
  });
  const [unidad, setUnidad] = useState({
    Id: selectedUnidad || "",
    Nombre: "",
  });
  const [cantidad, setCantidad] = useState(currentCantidad || 0);

  const handleChange = () => {
    unidades[index] = {
      ...unidades[index],
      unidad: unidad.Id,
      cantidad: cantidad,
    };
  };
  useEffect(() => {
    handleChange();
  }, [unidad, cantidad]);
  return (
    <Grid container spacing={3} padding={2} rowSpacing={1}>
      <Grid item xs={12} sm={6}>
        <DropDownList
          required
          title="Categoría"
          endpoint={"/categoria/listActive"}
          selectedItem={categoria}
          setSelectedItem={setCategoria}
          selected={selectedCategoria}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <DropDownList
          required
          title="Unidad"
          endpoint={
            categoria.Id !== ""
              ? `/unidad/listActive/${categoria.Id}`
              : undefined
          }
          selectedItem={unidad}
          setSelectedItem={setUnidad}
          disabled={categoria.Id === ""}
          hierarchyUpdated={categoria}
          selected={selectedUnidad}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          type="number"
          margin="normal"
          required
          fullWidth
          id="cantidad"
          label="Cantidad"
          name="cantidad"
          value={cantidad}
          inputProps={{
            step: constantes.decimales_unidades,
            min: 0,
            style: { textAlign: "right" },
          }}
          onChange={(e) => setCantidad(e.target.value)}
        />
      </Grid>
    </Grid>
  );
}

export { UnidadMedida };
